import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_open_question = _resolveComponent("open-question");
  const _component_quiz_readonly_alert = _resolveComponent("quiz-readonly-alert");
  return _openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["open-question-quiz-container", _ctx.isResultMode ? 'quiz-result-container' : ''])
  }, [_ctx.realtimeUserQuestions.length ? (_openBlock(), _createBlock(_component_open_question, {
    key: 0,
    quiz: _ctx.quiz,
    "user-questions-answers": _ctx.realtimeUserQuestions,
    "is-result-mode": _ctx.isResultMode,
    onAnswerChange: _ctx.onAnswerChange
  }, null, 8, ["quiz", "user-questions-answers", "is-result-mode", "onAnswerChange"])) : _createCommentVNode("", true), _ctx.canEdit ? (_openBlock(), _createBlock(_component_quiz_readonly_alert, {
    key: 1,
    "is-speach-template": _ctx.isSpeachTemplate
  }, null, 8, ["is-speach-template"])) : _createCommentVNode("", true)], 2);
}